var InstantMessageChannelHelper = /** @class */ (function () {
    function InstantMessageChannelHelper() {
    }
    InstantMessageChannelHelper.getFixedName = function (users, userCode) {
        var otherUsers = users.filter(function (i) { return i.userCode !== userCode; });
        if (otherUsers.length === 1) {
            return otherUsers[0].getName();
        }
        else {
            return null;
        }
    };
    InstantMessageChannelHelper.getPicture = function (users, picture, userCode) {
        if (picture) {
            return picture;
        }
        var otherUsers = users.filter(function (i) { return i.userCode !== userCode; });
        if (otherUsers.length > 1) {
            return "";
        }
        else if (otherUsers.length > 0) {
            return otherUsers[0].picture;
        }
        else {
            return "";
        }
    };
    InstantMessageChannelHelper.getPictureClass = function (users, picture, userCode) {
        if (InstantMessageChannelHelper.getPicture(users, picture, userCode)) {
            return "";
        }
        else {
            var otherUsers = users.filter(function (i) { return i.userCode !== userCode; });
            return otherUsers.length > 1 ? "icon instantMessageGroup" : "";
        }
    };
    InstantMessageChannelHelper.getAvatarId = function (users, picture, userCode) {
        if (InstantMessageChannelHelper.getPicture(users, picture, userCode)) {
            return "";
        }
        else {
            var otherUsers = users.filter(function (i) { return i.userCode !== userCode; });
            if (otherUsers.length > 1) {
                return "";
            }
            else if (otherUsers.length > 0) {
                return otherUsers[0].userCode;
            }
            else {
                return "";
            }
        }
    };
    return InstantMessageChannelHelper;
}());
export { InstantMessageChannelHelper };
